import type { DashboardTab } from "../state/dashboardReducer"

/** Map account-tab status multiselect to backend query param. */
export function resolveAccountStatusParam(statuses: string[]): string {
  const hasSpend = statuses.includes("WITH_SPEND")
  const withoutSpend = statuses.includes("WITHOUT_SPEND")
  const deleted = statuses.includes("DELETED")

  if (!hasSpend && !withoutSpend && !deleted) return "WITH_SPEND"
  if (hasSpend && !withoutSpend && !deleted) return "WITH_SPEND"
  if (!hasSpend && withoutSpend && !deleted) return "WITHOUT_SPEND"
  if (!hasSpend && !withoutSpend && deleted) return "DELETED"
  // Both spend buckets, no Deleted → every non-deleted account.
  if (hasSpend && withoutSpend && !deleted) return "NON_DELETED"
  // Any mix that includes Deleted → unrestricted (includes soft-deleted).
  return "all"
}

/** Map buyer-tab status multiselect to backend query param. */
export function resolveBuyerStatusParam(statuses: string[]): string {
  return statuses.length === 1 ? statuses[0] : "all"
}

/** Whether account status differs from the default active-only filter. */
export function isNonDefaultAccountStatusFilter(statuses: string[]): boolean {
  return (
    statuses.includes("WITHOUT_SPEND") ||
    statuses.includes("DELETED") ||
    (statuses.includes("WITH_SPEND") && statuses.includes("WITHOUT_SPEND"))
  )
}

export function countDashboardActiveFilters(
  selectedNetworks: string[],
  selectedStatuses: string[],
  selectedBuyers: number[],
  activeTab: DashboardTab,
): number {
  let count = 0
  if (selectedNetworks.length > 0) count++
  if (activeTab === "account") {
    if (isNonDefaultAccountStatusFilter(selectedStatuses)) count++
  } else if (selectedStatuses.length > 0) {
    count++
  }
  if (selectedBuyers.length > 0) count++
  return count
}
